// extracted by mini-css-extract-plugin
module.exports = {"container":"FormDatepicker_container__1IBrw","label":"FormDatepicker_label__1gDs4","input":"FormDatepicker_input__2I4AJ"};